var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 user-modal-login-view px-2" },
    [
      _c("Transition", { attrs: { name: "fade-grow", appear: "" } }, [
        _vm.emailSentText
          ? _c(
              "div",
              { staticClass: "py-3 px-4 text-white bg-info mb-5 rounded" },
              [
                _c("p", {
                  staticClass: "mb-0",
                  domProps: { innerHTML: _vm._s(_vm.emailSentText) },
                }),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-5 text-center" }, [
        _c("p", { staticClass: "font-weight-bold font-size-200 mb-0" }, [
          _vm._v(_vm._s(_vm._f("trans")("Log In"))),
        ]),
      ]),
      _vm._v(" "),
      _c("SocialLoginButtons", { staticClass: "mb-4 w-100 text-center" }),
      _vm._v(" "),
      _c("div", { staticClass: "mb-4 text-center text-lowercase" }, [
        _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Or")))]),
      ]),
      _vm._v(" "),
      _vm.showLoginWrongCredentialsError
        ? _c(
            "div",
            {
              staticClass: "text-danger font-weight-bold text-center mt-4 mb-3",
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("trans")("Incorrect username or password.")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mb-5",
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.attemptLogin.apply(null, arguments)
            },
          },
        },
        [
          _c("TextInput", {
            staticClass: "mb-4",
            attrs: {
              "data-user-modal-input-email": "",
              type: "email",
              name: "u_email",
              label: _vm._f("trans")("E-Mail or Username"),
              icon: "far fa-envelope",
              disabled: _vm.isSubmitting,
              "has-error":
                _vm.showLoginWrongCredentialsError ||
                _vm.usernameOrEmailError !== null,
              "current-error": _vm.usernameOrEmailError,
              "trim-input": true,
              autocomplete: "on",
            },
            on: { input: _vm.updateUsernameOrEmail },
          }),
          _vm._v(" "),
          _c("TextInput", {
            attrs: {
              "data-user-modal-input-password": "",
              type: "password",
              name: "u_password",
              label: _vm._f("trans")("Password"),
              icon: "far fa-lock",
              disabled: _vm.isSubmitting,
              "has-error":
                _vm.showLoginWrongCredentialsError ||
                _vm.passwordError !== null,
              "current-error": _vm.passwordError,
              "trim-input": false,
              autocomplete: "current-password",
            },
            on: { input: _vm.updatePassword },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ButtonWithLoadingState", {
        staticClass:
          "btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4",
        attrs: {
          "data-user-modal-button-submit": "",
          icon: "fa fa-sign-in",
          text: _vm._f("trans")("Log in"),
          "is-state-loading": _vm.isSubmitting,
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.attemptLogin.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm._f("trans")("Having trouble?")) +
            "\n        "
        ),
        _c(
          "a",
          {
            attrs: { "data-user-modal-link-help": "", href: "" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.goToHelpPage.apply(null, arguments)
              },
            },
          },
          [_vm._v(_vm._s(_vm._f("trans")("Get help")))]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center mt-2" },
        [
          _c(
            "RouterLink",
            {
              attrs: {
                "data-user-modal-link-reset-password": "",
                to: { name: _vm.userModalRoute.PASSWORD_RESET },
                disabled: _vm.isSubmitting,
                event: _vm.isSubmitting ? "" : "click",
                tag: "a",
              },
            },
            [
              _vm._v(
                _vm._s(_vm._f("trans")("Forgot your password?")) + "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "mb-4 mt-4" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("trans")("Don't have an account yet?")) +
              "\n        "
          ),
          _c(
            "RouterLink",
            {
              attrs: {
                "data-user-modal-link-register": "",
                to: { name: _vm.userModalRoute.REGISTER },
                disabled: _vm.isSubmitting,
                event: _vm.isSubmitting ? "" : "click",
                tag: "a",
              },
            },
            [_vm._v(_vm._s(_vm._f("trans")("Sign up")) + "\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }